import { take, all, takeLatest, call } from 'redux-saga/effects';
import { request } from '../../../xhr';
import { isApiError } from '../../../xhr/request';
import { addMediaToTier, reduxModuleLoaded } from './actions';
export function fakeResponse(options) {
    if (process.env.NODE_ENV !== 'production') {
        if (window.doError) {
            return {
                error: 'server_error',
                errorDescription: 'Could not create asset',
                status: 'error'
            };
        }
        return {
            success: true
        };
    }
}
function* handleAddMediaToTier(action) {
    // TODO types
    const data = {
        tier_deviationid: action.payload.tierDeviation.deviationId,
        deviationids: action.payload.deviations.map((d)=>d.deviationId)
    };
    // TODO types
    const response = yield call(request, {
        url: '/tier/deviation/add',
        method: 'post',
        data
    }, fakeResponse);
    if (!response) {
        // TODO error handling
        alert('oh no we messed up...');
        return;
    }
    if (isApiError(response)) {
        // TODO error handling
        alert('oh no we messed up...');
        return;
    }
    // TODO specs for success handling
    window.location.reload();
}
export default function* dasSaga() {
    yield take(reduxModuleLoaded); // wait for redux to load
    yield all([
        takeLatest(addMediaToTier, handleAddMediaToTier)
    ]);
}
